import ContextMenu from "../../../NotWorkArea(Side&Head)/ContextMenu";
import { createGrid, createRecordSource } from "../../../rcsgrid/rcsgrid";
import { getBookContextMenu } from "../../../Tools/Requests";
import { getDefaultMenu } from "../../../Tools/Tools";
import React from "react";

interface Props {
  contextMenuModule?: string;
  contextMenuHandler?: (data?: any) => void;
  changeDataOfItem?: (val: any) => any;
  mainGrid?: { grid: createGrid; source: createRecordSource };
  gridPanelRef: React.RefObject<any>;
  Module?: string;
  objType?: string;
  selectedRecordID?: string;
  SectionID?: string;
}

export default function MainTableContent(props: Props) {
  const {
    contextMenuModule,
    contextMenuHandler,
    changeDataOfItem,
    mainGrid,
    gridPanelRef,
    Module: module,
    objType,
    selectedRecordID,
    SectionID: sectionId,
  } = props;
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <ContextMenu
        for={contextMenuModule}
        Menu={getDefaultMenu(contextMenuModule)}
        changeDataOfItem={changeDataOfItem}
        onRightClick={async () => {
          const json = await getBookContextMenu(module, objType, selectedRecordID, sectionId);
          if (json && json.Items && json.Items.items) {
            return { arr: json.Items.items };
          }
        }}
        onMenuItemClick={contextMenuHandler}
        refs={{ current: mainGrid }}
      >
        <div
          id={`rcgrid_panel`}
          ref={gridPanelRef}
          style={{
            height: "100%",
            width: "100%",
            position: "relative",
          }}
        />
      </ContextMenu>
    </div>
  );
}
